export default {
  showTestimonials(state) {
    console.log('mutations showTestimonials');
    state.showTestimonials = true;
  },
  hideTestimonials(state) {
    console.log('mutations hideTestimonials');
    state.showTestimonials = false;
  },
  showFinalScore(state) {
    console.log('mutations showFinalScore');
    state.showFinalScore = true;
  },
  hideFinalScore(state) {
    console.log('mutations hideFinalScore');
    state.showTestimonials = false;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js